import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import styles from './_index.module.css';

interface ExperienceOption {
  id: string;
  title: string;
  pricePrefix?: string;
  price: string;
  priceSubtext?: string;
  duration: string;
  whatYoullLearn: string;
  features: string[];
}

const experienceOptions: ExperienceOption[] = [
  {
    id: 'towing101',
    title: 'Towing 101 Classroom Session',
    price: 'FREE',
    duration: '60 minutes',
    whatYoullLearn: 'Get towing basics with key terminology, capacity calculations³, and pre-trip safety checks',
    features: [
      'Classroom session',
      'Pre-trip safety checks',
      'Towing capacity calculations',
      'Advanced towing technology',
    ],
  },
  {
    id: 'trailerDemo',
    title: 'Ford Pro Trailer Backup Assist™ and Pro Trailer Hitch Assist™ Demo⁴',
    price: 'FREE',
    duration: '30 minutes',
    whatYoullLearn:
      'See Ford towing tech in action as a CDL instructor demonstrates the Ford Pro Trailer Backup Assist and Pro Trailer Hitch Assist features to help in learning trailer maneuvering basics⁴.',
    features: ['Live tech demonstration', 'Advanced towing technology', 'Expert learning with a CDL instructor'],
  },
  {
    id: 'trailerBackUp',
    title: 'Hands-On Trailer Backup Experience',
    pricePrefix: 'Starting at',
    price: '$185',
    priceSubtext: 'per person²',
    duration: '2 hours',
    whatYoullLearn: 'Practice backing up and hooking up a trailer with expert coaching',
    features: [
      'Towing 101 Classroom Session (one hour)',
      'Ford Pro Trailer Backup Assist and Pro Trailer Hitch Assist Demo Session (30 minutes)',
      '30 minutes of **shared** hands-on trailer backup experience⁴',
      'Live tech demonstration',
      'Advanced towing technology',
      'Expert coaching with a CDL instructor',
    ],
  },
  {
    id: 'ultimateTowing',
    title: 'The Ultimate Towing Experience',
    pricePrefix: 'Starting at',
    price: '$350',
    priceSubtext: 'per person²',
    duration: '3 hours',
    whatYoullLearn: 'Get hands on with advanced towing technology and extensive hands-on practice',
    features: [
      'Towing 101 Classroom Session (one hour)',
      'Ford Pro Trailer Backup Assist and Pro Trailer Hitch Assist Demo Session (30 minutes)⁴',
      '1.5 hours of **shared** hands-on trailer backup experience',
      'Advanced towing technology',
      'Expert coaching with a CDL instructor',
    ],
  },
];

export function ExperienceOptions() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentSection}>
        <h2 className="headline-3-small-semibold">Bootcamp Experience Options</h2>
        <p className={`body-1-regular ${styles.subtitle}`}>
          Options range from free¹ introductory sessions to comprehensive hands-on training.
        </p>

        <div className={styles.cardGrid}>
          {experienceOptions.map((option) => (
            <div key={option.id} className={styles.card}>
              <div className={styles.cardHeader}>
                <h3 className={styles.cardTitle}>{option.title}</h3>
                <div className={styles.priceWrapper}>
                  {option.pricePrefix && <span className={styles.pricePrefix}>{option.pricePrefix}</span>}
                  <span className={styles.price}>{option.price}</span>
                  {option.priceSubtext && <span className={styles.priceSubtext}>{option.priceSubtext}</span>}
                </div>
              </div>

              <div className={styles.whatYoullLearn}>
                <strong className={styles.featuresLabel}>What you'll learn:</strong>
                <p className={styles.learnText}>{option.whatYoullLearn}</p>
              </div>

              <div className={styles.featuresSection}>
                <strong className={styles.featuresLabel}>What's included:</strong>
                <ul className={styles.featureList}>
                  {option.features.map((feature, index) => {
                    // Parse **bold** markers in feature text
                    const parts = feature.split(/\*\*(.*?)\*\*/);
                    return (
                      <li key={index} className={styles.featureItem}>
                        <FontAwesomeIcon icon={faCircleCheck as IconProp} className={styles.checkIcon} />
                        <span>
                          {parts.map((part, i) =>
                            i % 2 === 1 ? <strong key={i}>{part}</strong> : part
                          )}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
